import styled from "styled-components";

export const Styles = styled.div`
  position: relative;
  & {
    overflow: auto;
    height: 100%;
    padding-bottom: 50px;
  }
  &.mode_preview {
    height: 100%;
    padding-top: 0px;
    .container_rich-text {
      .ql-editor {
        padding: 0;
        border-top: 1px solid #ccc;
      }
    }
    .icon_attachment {
      display: none !important;
    }

    .ant-table-wrapper {
      .container_rich-text {
        .ql-container {
          border: none;
        }
        .ql-toolbar {
          display: none;
        }
        .toolbar_read_only {
          display: none;
        }
        .ql-editor {
          padding: 0;
          min-height: 0px !important;
          border: none;
        }
      }
    }
  }
  .ant-form-item {
    margin: 0;
  }
  .ant-picker-input {
    input {
      padding-right: 0;
    }
  }
  .selection-menu {
    min-width: 150px !important;
  }
  .branch-icon {
    min-width: 40px;
  }
  .column-no-permission {
    height: 100%;
    .text {
      min-height: 32px;
      background-color: #f9dedc;
      padding: 6px;
      padding-left: 10px;
      color: #969696;
    }
  }
  .layout {
    div {
      padding-right: 1px;
    }
    .full {
      div:first-child {
        width: 100%;
      }
    }
  }

  .app-calculated {
    background-color: #fff !important;
    &::placeholder {
      color: #000000;
    }
  }

  button {
    background-color: #174a83;
    border-color: #174a83;
    border-radius: 8px;
    height: 34px;
    display: inline-flex;
    align-items: center;
    // margin-right: 8px;
  }
  input {
    width: 100%;
    padding: 10px;
    border-radius: 4px;
    height: 44px;
  }
  .mar-b-20 {
    margin-bottom: 20px;
  }
  .ml-10 {
    margin-left: 10px;
  }
  .ant-upload-btn {
    padding: 0 !important;
  }
  .ant-upload-list-item-name {
    color: black;
  }
  .ant-upload-list-item-card-actions-btn {
    background-color: white;
    margin: 0;
    width: 100%;
  }
  .ant-upload-text-icon {
    svg {
      color: black;
    }
  }
  .layout div {
    padding-right: 0;
  }
  .center {
    position: fixed;
    right: 50px;
    top: 80px;
    .ant-form-item-control-input {
      background-color: transparent !important;
      .ant-form-item-control-input-content {
        display: flex;
        gap: 8px;
      }
    }
  }
  .ant-input-number {
    border-radius: 4px;
    input {
      height: 43px;
      padding: 0 24px;
    }
    .ant-input-number-handler-wrap {
      display: none;
    }
  }
  .ant-picker {
    width: 100%;
    padding: 0;
    height: 44px;
    padding-right: 5px !important;
  }
  .ant-upload-list-item-name {
    cursor: pointer;
  }
  .rdw-editor-wrapper {
    border: 1px solid #d9d9d9;
  }
  .sub-error {
    margin-top: -24px;
  }
  .rdw-editor-toolbar {
    max-height: 160px;
    overflow: auto;
  }
  .flex-space {
    display: flex;
    justify-content: space-around;
    svg {
      cursor: pointer;
    }
  }
  .ant-table-cell {
    .ant-form-item {
      margin-bottom: 0px;
      .ant-form-item-label {
        height: 0px !important;
        padding: 0px !important;
      }
    }
  }
  .ant-select-selector {
    padding: 6px 8px !important;
    min-height: 44px !important;
    // max-height: 85px;
    // overflow: auto;
    .ant-select-selection-overflow {
      &::-webkit-scrollbar {
        width: 10px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: rgb(139 139 139);
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #555;
        cursor: context-menu;
      }
    }
  }

  .ant-radio-group,
  .ant-checkbox-group {
    padding-top: 11px;
    padding-left: 10px;
  }
  .org-infor {
    display: flex;
    gap: 5px;
    margin-right: 12px;
    padding: 2px 0;
  }
  .no-wrap-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ant-form-item-control-input {
    background-color: #ffffff;
  }
  .check-box,
  .radio-button {
    .ant-form-item-control {
      overflow-x: scroll;
      background: #fff;
      height: 44px;
      &::-webkit-scrollbar {
        height: 10px;
        width: 0px;
      }
      &::-webkit-scrollbar-track {
        background: transparent;
      }
      &::-webkit-scrollbar-thumb {
        background: rgb(139 139 139);
      }
      &::-webkit-scrollbar-thumb:hover {
        background: #555;
        cursor: context-menu;
      }
    }
  }
  .rich-text {
    .ant-form-item {
      height: 100%;
      .ant-form-item-row {
        height: 100%;
        .ant-form-item-control {
          height: calc(100% - 30px);
          .ant-form-item-control-input {
            height: 100%;
            .ant-form-item-control-input-content {
              height: 100%;
              .rdw-editor-wrapper {
                height: 100%;
              }
              .rdw-editor-toolbar {
                height: 70px;
              }
              .rdw-editor-main {
                height: calc(100% - 75px);
                background-color: #ffffff;
              }
            }
          }
        }
      }
    }
  }

  .quill {
    height: 100%;
    .ql-toolbar {
      button {
        margin-right: 0;
      }
    }
    button {
      min-width: unset;
    }
    .ql-container {
      .ql-editor {
        background: #fff;
      }
    }
  }
  .container-area {
    .ant-form-item {
      height: 100%;
      .ant-row {
        height: 100%;
        .ant-col {
          .ant-form-item-control-input {
            height: 100%;
            .ant-form-item-control-input-content {
              height: 100%;
              textarea {
                height: 100%;
              }
            }
          }
        }
      }
    }
  }
  .container-col {
    .collapse-table {
      .ant-table-tbody {
        display: none;
      }
    }
    &:has(.ql-tooltip) {
      z-index: 1;
    }

    &:has(.ql-expanded) {
      z-index: 1;
    }
  }
  .ant-upload.ant-upload-drag p.ant-upload-drag-icon {
    margin: 0;
    height: 40px;
  }
  .type-attachment {
    .ant-form-item {
      .ant-row {
        height: 100%;
        flex-direction: column;
        .ant-form-item-control {
          flex: 1;
          .ant-form-item-control-input-content {
            height: 100%;
            & > span {
              display: flex;
              flex-direction: column;
              height: 100%;
              .ant-upload {
                max-height: 100px;
              }
            }
          }
        }
      }
    }
  }
  .label_container {
    background: #fff;
  }

  .ant-table-wrapper {
    .ant-form-item {
      line-height: 0;
    }

    .ant-radio-group,
    .ant-checkbox-group {
      padding-top: 0;
    }
  }
  // .react-grid-layout {
  //   width: 2400px;
  //   background-size: 25px 25px;
  //   background-image: linear-gradient(to right, #e4e4e4 1px, transparent 1px),
  //     linear-gradient(to bottom, #e4e4e4 1px, #f7f9fa 1px);
  //   .react-grid-item {
  //     background: #ccc;
  //   }
  // }
`;

export const StylesCustomMultichoice = styled.div`
  border: 1px solid #3199dc;

  .item {
    width: 100%;
    padding-left: 8px;
  }

  .item-default {
    color: #178dd8;
  }

  .item-selected {
    background-color: #e3f2fe;
  }
`;

export const StyledButton = styled.div`
  display: flex;
  margin-right: 30px;
  justify-content: flex-end;
  position: sticky;
  top: 0px;
  left: 0px;
  z-index: 1;
`;
